import { useRef } from 'react'
import styled from 'styled-components'

const Row = styled.div`
    display: flex;
    gap: 0.75rem;
    justify-content: center;
`

const Box = styled.input`
    width: 48px;
    height: 48px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 600;
    border: 1px solid ${({ theme }) => theme.border?.color || '#d1d5db'};
    border-radius: 0.5rem;
    background: transparent;
    color: ${({ theme }) => theme.font?.color || '#333'};
    caret-color: transparent;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.btn?.primary || '#2563eb'};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.btn?.primary || '#2563eb'}33;
    }
`

const PinInput = ({ values, onChange, type = 'text', autoFocus = false }) => {
    const refs = [useRef(), useRef(), useRef(), useRef()]

    const handleChange = (index, e) => {
        const digit = e.target.value.replace(/[^0-9]/g, '').slice(-1)
        const next = [...values]
        next[index] = digit
        onChange(next)
        if (digit && index < 3) refs[index + 1].current?.focus()
    }

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !values[index] && index > 0) {
            refs[index - 1].current?.focus()
        }
    }

    const handlePaste = (e) => {
        e.preventDefault()
        const digits = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 4)
        const next = ['', '', '', '']
        for (let i = 0; i < digits.length; i++) next[i] = digits[i]
        onChange(next)
        const focusIndex = Math.min(digits.length, 3)
        refs[focusIndex].current?.focus()
    }

    return (
        <Row>
            {values.map((val, i) => (
                <Box
                    key={i}
                    ref={refs[i]}
                    type={type}
                    inputMode="numeric"
                    pattern="[0-9]"
                    maxLength={1}
                    value={val}
                    onChange={(e) => handleChange(i, e)}
                    onKeyDown={(e) => handleKeyDown(i, e)}
                    onPaste={handlePaste}
                    autoFocus={autoFocus && i === 0}
                />
            ))}
        </Row>
    )
}

export default PinInput
